import React from 'react';

var img1 = require('./../../images/background/bg-6.png');
var img2 = require('./../../images/background/line.png');

class AboutSummary extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b80 bg-dark bg-repeat square_shape2 inner-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-left">
                                <div className="mt-separator text-white">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">About</span> Summary</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        <div className="section-content our-story">
                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                            <img src={require('./../../images/special.jpg')} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-6">
                                    <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                        <h4 className="text-uppercase m-b20">Established in 2016.</h4>
                                        <h4 className="m-b20">From One Wardrobe to a Legacy of Beautiful Interiors </h4>
                                        <p>Founded by Mr. A.Kerpal, ENN Living Interiors was born out of a passion for
                                            craftsmanship and design. It all started on 2016, with a single handcrafted
                                            wardrobe and a vision to bring timeless design to modern homes.
                                            Since then, we’ve grown into a trusted interiors partner, working with hundreds of happy
                                            clients spread across serval parts of England  . What hasn’t changed is our commitment to
                                            personal service, premium quality, and turning your ideas into reality—down to the finest
                                            detail. </p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                            <img src={require('./../../images/special-1.jpeg')} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-6">
                                    <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                        <h4 className="text-uppercase m-b20">Vision, Mission & Value </h4>
                                        <h4 className="m-b20">Our Mission </h4>
                                        <p>To design spaces that are as beautiful as they are functional—crafted to suit your lifestyle,
                                            values, and vision.  </p>
                                        <h4 className="m-b20">Our Vision </h4>
                                        <p>To become the most trusted name in personalised home interiors across the UK—
                                            celebrated for our design innovation, reliability, and the ability to make every space
                                            uniquely meaningful.   </p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                            <img src={require('./../../images/special-2.webp')} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-6">
                                    <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                        <h4 className="m-b20">Our Core Values</h4>
                                        <p>• Craftsmanship: We care about the details. From materials to finishing, quality comes
                                            first.
                                            • Honesty: Transparent communication and pricing—no surprises.
                                            • Creativity: We love challenges and turning your unique ideas into reality.
                                            • Trust: Our long-standing team ensures consistency, professionalism, and care in
                                            every step.  </p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="our-story-pic-block">
                                        <div className="mt-media our-story-pic">
                                            <img src={require('./../../images/special-3.webp')} alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-6">
                                    <div className="mt-box our-story-detail bg-moving bg-cover" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                        <h4 className="m-b20">Our Process </h4>
                                        <p>A Collaborative, Stress-Free Journey from Start to Finish
                                            1. Consultation
                                            Visit our showroom in Uxbridge to explore materials, finishes, and share your vision.
                                            2. Design & Planning
                                            We take final measurements and refine the design to suit your needs, space, and
                                            budget.
                                            3. Craft & Install
                                            Once approved, we begin production and schedule installation with our trusted in
                                            house team.
                                            You stay informed throughout the process—and we ensure everything is completed to your
                                            satisfaction. </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default AboutSummary;